import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=37a9e3ab&scoped=true&"
import script from "./ChatWidget.vue?vue&type=script&lang=ts&"
export * from "./ChatWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=37a9e3ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9e3ab",
  null
  
)

export default component.exports